import React, { useState } from 'react';
import apiFetch from '../../../apiClient';
import { Botao, Campo } from '../../egora';
import { EntradaCabeca, EntradaErro } from './EntradaMoldura';

/**
 * "Esqueci minha senha" — só pede o e-mail (item 4C, 16/10/2026).
 *
 * O servidor responde SEMPRE a mesma coisa, exista ou não a conta (AUT-06),
 * e manda ao e-mail de acesso um link de uso único, válido por 10 minutos.
 * Quem abre o link cai em `/redefinir-senha` (RedefinirSenha.jsx).
 * A prancheta mostra um código de 6 números: o sistema usa o link, que é mais seguro.
 */
const RecuperarSenha = ({ onVoltar }) => {
  const [email, setEmail] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [mensagem, setMensagem] = useState('');
  const [erro, setErro] = useState('');

  const handleSolicitar = async (e) => {
    e.preventDefault();
    setCarregando(true);
    setErro('');
    try {
      const res = await apiFetch('/api/auth/forgot-password', {
        method: 'POST',
        body: JSON.stringify({ email }),
      });
      const corpo = await res.json();
      if (res.ok) {
        setMensagem(corpo?.data?.mensagem || 'Se este e-mail tiver acesso, enviamos um link.');
      } else {
        setErro(corpo?.error?.message || corpo?.detail || 'Não foi possível enviar agora. Tente de novo em instantes.');
      }
    } catch (_) {
      setErro('Não foi possível falar com o servidor. Verifique sua conexão.');
    } finally {
      setCarregando(false);
    }
  };

  return (
    <>
      <EntradaCabeca
        icone="lock_reset"
        titulo="Recuperar senha"
        texto="Informe o e-mail que você usa para entrar. Enviamos um link de uso único, válido por 10 minutos."
      />
      <EntradaErro>{erro}</EntradaErro>

      {mensagem ? (
        <div className="entrada__mensagem" role="status">
          <span className="sj-icone sj-icone--cheio" aria-hidden="true">mark_email_read</span>
          <span>{mensagem}</span>
        </div>
      ) : (
        <form onSubmit={handleSolicitar}>
          <Campo rotulo="E-mail de acesso">
            {(p) => (
              <input
                {...p}
                className="sj-campo__entrada"
                type="email"
                required
                maxLength={254}
                autoComplete="email"
                placeholder="nome@escritorio.adv.br"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            )}
          </Campo>
          <Botao type="submit" carregando={carregando} className="entrada__entrar">
            {carregando ? 'Enviando' : 'Enviar link'}
          </Botao>
        </form>
      )}

      <Botao variante="fantasma" onClick={onVoltar}>Voltar para o login</Botao>
    </>
  );
};

export default RecuperarSenha;
